import { httpClient } from 'angieslist-app-platform';

export const getAgreementStatus = (userId, pactsafeAccessId) =>
  httpClient.get(`https://pactsafe.io/latest?sig=${userId}&sid=${pactsafeAccessId}&gkey=office-site`);

export default { getAgreementStatus };



// WEBPACK FOOTER //
// ./src/app/common/agreement/agreementService.js